import { useEffect } from 'react';

/**
 * Hook that scrolls to the top of the page when the component mounts
 * Should be used in route components to reset scroll position on navigation
 *
 * @example
 * ```tsx
 * const Dashboard = () => {
 *   useScrollToTop();
 *   return <div>Dashboard content</div>;
 * };
 * ```
 */
export const useScrollToTop = () => {
  useEffect(() => {
    globalThis.scrollTo(0, 0);
  }, []);
};
